/*
 *
 * LanguageProvider
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';

import { useLocaleStore } from 'stores/useLocaleStore';

export function LanguageProvider(props) {
  const locale = useLocaleStore((state) => state.locale);

  return (
    <IntlProvider
      locale={locale}
      key={locale}
      messages={props.messages[locale]}
    >
      {React.Children.only(props.children)}
    </IntlProvider>
  );
}

LanguageProvider.propTypes = {
  messages: PropTypes.object,
  children: PropTypes.element.isRequired,
};

export default LanguageProvider;
